import React from "react";
import { useLocation } from "react-router-dom";

const getPaymentDetails = (search) => {
  const searchParams = new URLSearchParams(search);

  return {
    mode: searchParams.get("mode"),
    status: searchParams.get("status"),
    txnid: searchParams.get("txnid"),
    amount: searchParams.get("amount"),
    field9: searchParams.get("field9"),
  };
};

const formatAmount = (amount) => {
  if (!amount) {
    return "N/A";
  }

  const parsedAmount = Number.parseFloat(amount);
  return Number.isNaN(parsedAmount) ? amount : `${parsedAmount.toFixed(2)} INR`;
};

const MobilePaymentFailure = () => {
  const location = useLocation();
  const paymentDetails = getPaymentDetails(location.search);

  return (
    <div className="vv-payment-failure-container">
      <div className="vv-failure-card">
        <div className="vv-failure-icon">!</div>
        <h1 className="vv-failure-heading">Payment Failed</h1>
        <p className="vv-failure-text">
          We could not complete your payment. You can return to the app and try again.
        </p>

        <div className="vv-payment-failure-details">
          <h3>Transaction Details</h3>
          <div className="vv-failure-detail-item">
            <span>Transaction ID:</span>
            <span>{paymentDetails.txnid || "N/A"}</span>
          </div>
          <div className="vv-failure-detail-item">
            <span>Amount:</span>
            <span>{formatAmount(paymentDetails.amount)}</span>
          </div>
          <div className="vv-failure-detail-item">
            <span>Payment Mode:</span>
            <span>{paymentDetails.mode || "N/A"}</span>
          </div>
          <div className="vv-failure-detail-item">
            <span>Status:</span>
            <span>{paymentDetails.field9 || paymentDetails.status || "Unknown Error"}</span>
          </div>
        </div>

        <p className="vv-failure-help-text">
          Please contact support at 1800 103 4916 or support@indusviva.com if the issue persists.
        </p>
      </div>
    </div>
  );
};

export default MobilePaymentFailure;
